import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, useScroll, useSpring } from 'framer-motion';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import BookingPage from './pages/BookingPage';
import ReviewPage from './pages/ReviewPage';
import GuidesPage from './pages/GuidesPage';
import CompliancePage from './pages/CompliancePage';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import MisconductPopup from './components/MisconductPopup';

function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <Router>
      <ScrollToTop />
      <div className="relative z-10 overflow-x-hidden selection:bg-brand-gold selection:text-brand-navy">
        <motion.div
          className="fixed left-0 right-0 top-0 z-[60] h-1 origin-left bg-brand-gold"
          style={{ scaleX }}
        />
        <MisconductPopup />
        <Navbar />
        <main className="relative">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/guides" element={<GuidesPage />} />
            <Route path="/compliance" element={<CompliancePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;